import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "file-attachment" }
const _hoisted_2 = { class: "file-attachment__card" }
const _hoisted_3 = { class: "file-attachment__icon-wrapper" }
const _hoisted_4 = { class: "file-attachment__content" }
const _hoisted_5 = { class: "file-attachment__info" }
const _hoisted_6 = { class: "file-attachment__name" }
const _hoisted_7 = {
  key: 0,
  class: "file-attachment__size"
}
const _hoisted_8 = ["disabled"]

import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";
import { useAttachmentDownload } from "@/composables/attachments/useAttachmentDownload";
import ProgressCircle from "./ProgressCircle.vue";

interface Props {
  attachment: Attachment;
  messageId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileAttachment',
  props: {
    attachment: {},
    messageId: {}
  },
  setup(__props: any) {

const props = __props;

const { isDownloading, isLoading, loadingProgress, download } = useAttachmentDownload(
  props.attachment,
  props.messageId
);

const handleDownload = () => {
  download("application/octet-stream", `attachment_${props.attachment.id}`);
};

const getFileIcon = (mimetype?: string): string => {
  if (!mimetype) return "mdi:file";
  if (mimetype.startsWith("image/")) return "mdi:file-image";
  if (mimetype.startsWith("video/")) return "mdi:file-video";
  if (mimetype.startsWith("audio/")) return "mdi:file-music";
  if (mimetype.includes("pdf")) return "mdi:file-pdf-box";
  if (mimetype.includes("word") || mimetype.includes("document")) return "mdi:file-word";
  if (mimetype.includes("excel") || mimetype.includes("spreadsheet")) return "mdi:file-excel";
  if (mimetype.includes("powerpoint") || mimetype.includes("presentation"))
    return "mdi:file-powerpoint";
  if (mimetype.includes("zip") || mimetype.includes("archive")) return "mdi:folder-zip";
  return "mdi:file";
};

const formatFileSize = (bytes?: number): string => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Icon), {
          icon: getFileIcon(__props.attachment.mimetype),
          class: "file-attachment__icon"
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(__props.attachment.file_name || __props.attachment.name || "File"), 1),
          (
              __props.attachment.file_size ||
              (typeof __props.attachment.size === 'number' ? __props.attachment.size : undefined)
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(formatFileSize(
                __props.attachment.file_size ||
                  (typeof __props.attachment.size === "number" ? __props.attachment.size : undefined)
              )), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "file-attachment__download",
        onClick: _withModifiers(handleDownload, ["stop"]),
        disabled: _unref(isDownloading),
        title: "Download file"
      }, [
        (_unref(isDownloading) && _unref(loadingProgress) > 0)
          ? (_openBlock(), _createBlock(ProgressCircle, {
              key: 0,
              progress: _unref(loadingProgress),
              size: "small",
              "bg-stroke": "rgba(0, 0, 0, 0.1)",
              "fill-stroke": "#111827",
              "show-text": false
            }, null, 8, ["progress"]))
          : (_unref(isDownloading))
            ? (_openBlock(), _createBlock(_unref(Icon), {
                key: 1,
                icon: "mdi:loading",
                class: "file-attachment__spinner"
              }))
            : (_openBlock(), _createBlock(_unref(Icon), {
                key: 2,
                icon: "mdi:download"
              }))
      ], 8, _hoisted_8)
    ])
  ]))
}
}

})